/**
 * @todo: After v1 website we should make it editable by admin panel.
 */

/** @private */
const definitionModel = (countryIn, currencyIn, countryOut, currencyOut) => {
    return {countryIn, currencyIn, countryOut, currencyOut}
};

export const calculatorGeoDefinitions = (location) => {
    switch (location) {
    case 'AM':
        return definitionModel('PL', 'PLN', 'AM', 'AMD');
    case 'AT':
        return definitionModel('AT', 'EUR', 'PL', 'PLN');
    case 'AZ':
        return definitionModel('PL', 'PLN', 'AZ', 'AZN');
    case 'BE':
        return definitionModel('BE', 'EUR', 'PL', 'PLN');
    case 'BG':
        return definitionModel('BG', 'EUR', 'PL', 'PLN');
    case 'BY':
        return definitionModel('PL', 'PLN', 'BY', 'BYN');
    case 'CH':
        return definitionModel('PL', 'PLN', 'CH', 'CHF');
    case 'CY':
        return definitionModel('CY', 'EUR', 'PL', 'PLN');
    case 'CZ':
        return definitionModel('CZ', 'EUR', 'PL', 'PLN');
    case 'DE':
        return definitionModel('DE', 'EUR', 'PL', 'PLN');
    case 'DK':
        return definitionModel('DK', 'DKK', 'PL', 'PLN');
    case 'EE':
        return definitionModel('EE', 'EUR', 'PL', 'PLN');
    case 'ES':
        return definitionModel('ES', 'EUR', 'PL', 'PLN');
    case 'FI':
        return definitionModel('FI', 'EUR', 'PL', 'PLN');
    case 'FR':
        return definitionModel('FR', 'EUR', 'PL', 'PLN');
    case 'GB':
        return definitionModel('GB', 'GBP', 'PL', 'PLN');
    case 'GE':
        return definitionModel('PL', 'PLN', 'GE', 'GEL');
    case 'GR':
        return definitionModel('GR', 'EUR', 'PL', 'PLN');
    case 'HR':
        return definitionModel('HR', 'EUR', 'PL', 'PLN');
    case 'HU':
        return definitionModel('HU', 'EUR', 'PL', 'PLN');
    case 'IE':
        return definitionModel('IE', 'EUR', 'PL', 'PLN');
    case 'IS':
        return definitionModel('IS', 'EUR', 'PL', 'PLN');
    case 'IT':
        return definitionModel('IT', 'EUR', 'PL', 'PLN');
    case 'KG':
        return definitionModel('PL', 'PLN', 'KG', 'KGS');
    case 'KZ':
        return definitionModel('PL', 'PLN', 'KZ', 'KZT');
    case 'LI':
        return definitionModel('LI', 'EUR', 'PL', 'PLN');
    case 'LT':
        return definitionModel('LT', 'EUR', 'PL', 'PLN');
    case 'LU':
        return definitionModel('LU', 'EUR', 'PL', 'PLN');
    case 'LV':
        return definitionModel('LV', 'EUR', 'PL', 'PLN');
    case 'MD':
        return definitionModel('PL', 'PLN', 'MD', 'MDL');
    case 'MT':
        return definitionModel('MT', 'EUR', 'PL', 'PLN');
    case 'NL':
        return definitionModel('NL', 'EUR', 'PL', 'PLN');
    case 'NO':
        return definitionModel('NO', 'NOK', 'PL', 'PLN');
    case 'PL':
        return definitionModel('PL', 'PLN', 'GB', 'GBP');
    case 'PT':
        return definitionModel('PT', 'EUR', 'PL', 'PLN');
    case 'RO':
        return definitionModel('RO', 'EUR', 'PL', 'PLN');
    case 'RU':
        return definitionModel('PL', 'PLN', 'RU', 'RUB');
    case 'SE':
        return definitionModel('SE', 'SEK', 'PL', 'PLN');
    case 'SI':
        return definitionModel('SI', 'EUR', 'PL', 'PLN');
    case 'SK':
        return definitionModel('SK', 'EUR', 'PL', 'PLN');
    case 'SM':
        return definitionModel('SM', 'EUR', 'PL', 'PLN');
    case 'TJ':
        return definitionModel('PL', 'PLN', 'TJ', 'TJS');
    case 'TM':
        return definitionModel('PL', 'PLN', 'TM', 'TMT');
    case 'UA':
        return definitionModel('PL', 'PLN', 'UA', 'UAH');
    case 'UZ':
        return definitionModel('PL', 'PLN', 'UZ', 'UZS');
    default:
        return definitionModel('GB', 'GBP', 'PL', 'PLN');
    }
};
